// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2E4Ef","inputDescription":"styles_inputDescription__14u2R"};